import React from "react"
import style from "./Brands.module.scss"

export default ({ children }) => {
  return (
    <section className={style.container}>
      <div>
        {children}
      </div>
    </section>
  )
}
